exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selector-btn {\n  width: 100%;\n  border-radius: 2px;\n  box-shadow: none;\n  padding: 3px 12px;\n  height: 24px;\n  font-size: 14px;\n  line-height: 1.3rem;\n  text-transform: none !important; }\n\n.theme-selector-item {\n  font-size: 14px;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.theme-selector-item:hover {\n  background: #DADADC !important; }\n\n.dropdown-item ::ng-deep li {\n  height: 28px;\n  max-height: 28px;\n  min-height: 28px; }\n\n.dropdown-item ::ng-deep a {\n  padding: 3px 6px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/epic-selector/epic-selector.component.scss
// module id = ../../../../../src/app/components/epic-selector/epic-selector.component.scss
// module chunks = main